import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

import { ServicePickModalComponent } from '../../shared/service-pick-modal/service-pick-modal.component';
import { PlacePickModalComponent } from '../../shared/place-pick-modal/place-pick-modal.component';
import { DatePickModalComponent } from '../../shared/date-pick-modal/date-pick-modal.component';
import { HoursPickModalComponent } from '../../shared/hours-pick-modal/hours-pick-modal.component';
import { SearchPreferencesService } from '../../core/services/search-preferences.service';
import { SearchPreferences } from '../../core/models/search-preferences/search-preferences.model';

import { Observable } from 'rxjs';
import { first, map, flatMap, tap, switchMap, switchAll, take } from 'rxjs/operators';

class Port {
  public id: number;
  public name: string;
}

@Component({
  selector: 'app-search-by-service',
  templateUrl: './search-by-service.component.html',
  styleUrls: ['./search-by-service.component.scss'],
})
export class SearchByServiceComponent implements OnInit {

  @Input() selectedService: string;

  searchPreferences$: Observable<SearchPreferences>;

  constructor( 
    private router: Router,
    private modalCtrl: ModalController,
    private searchPreferencesService: SearchPreferencesService 
  ) {
    this.searchPreferences$ = searchPreferencesService.searchPreferences$;
  }

  ngOnInit() {

  }

  openPickServiceModal( searchPreferences: SearchPreferences ) {
    this.searchPreferencesService.openModal( 'service', searchPreferences );
  }

  openPickPlaceModal( searchPreferences: SearchPreferences ) {
    this.searchPreferencesService.openModal( 'place', searchPreferences );
  }

  openPickDateModal( searchPreferences: SearchPreferences ) {
    this.searchPreferencesService.openModal( 'date', searchPreferences );
  }

  openPickHoursModal( searchPreferences: SearchPreferences ) {
    this.searchPreferencesService.openModal( 'time', searchPreferences );
  }

  searchShopsByPreferences() {
    this.searchPreferencesService.navigateToShopListing();
  }

  resetNormalizedService(event) {
    event.stopPropagation();
    this.searchPreferencesService.updatePreference( 'normalizedService', null );
  }

  resetPlace(event) {
    event.stopPropagation();
    this.searchPreferencesService.updatePreference( 'place', null );
  }

  resetDate(event) {
    event.stopPropagation();
    this.searchPreferencesService.updatePreference( 'datePeriod', null );
  }

  resetHours(event) {
    event.stopPropagation();
    this.searchPreferencesService.updatePreference( 'hoursPeriod', null );
  }

}